<template>
  <div class="container">
    <router-link :to="{ name: 'admin-tweets' }">
      <svg
        width="24"
        height="22"
        viewBox="0 0 24 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.58 6.35001L12.475 0.897008C12.178 0.737008 11.821 0.737008 11.525 0.897008L1.425 6.35001C0.939003 6.61401 0.758003 7.22001 1.02 7.70601C1.2 8.04101 1.545 8.23101 1.9 8.23101C2.06 8.23101 2.224 8.19301 2.375 8.11101L3.109 7.71501L4.699 18.965C4.915 20.179 6.009 21.027 7.359 21.027H16.641C17.991 21.027 19.085 20.179 19.303 18.939L20.891 7.71401L21.628 8.11201C22.113 8.37501 22.72 8.19401 22.982 7.70801C23.245 7.22201 23.062 6.61501 22.578 6.35301L22.58 6.35001ZM12 14.435C10.205 14.435 8.75 12.98 8.75 11.185C8.75 9.39001 10.205 7.93501 12 7.93501C13.795 7.93501 15.25 9.39001 15.25 11.185C15.25 12.98 13.795 14.435 12 14.435Z"
          fill="#FF6600"
        />
      </svg>
    </router-link>
    <div class="post-item" v-show="isUserPage" @click="$emit('openModal')">
      <svg
        width="24"
        height="22"
        viewBox="0 0 24 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.8 5.20001H5.6V1.90001C5.6 1.50001 5.3 1.10001 4.8 1.10001C4.3 1.10001 4.1 1.50001 4.1 1.90001V5.20001H0.8C0.4 5.20001 0 5.50001 0 6.00001C0 6.50001 0.3 6.80001 0.8 6.80001H4.1V10.1C4.1 10.5 4.4 10.9 4.9 10.9C5.4 10.9 5.7 10.6 5.7 10.1V6.70001H9C9.4 6.70001 9.8 6.40001 9.8 5.90001C9.8 5.40001 9.3 5.20001 8.8 5.20001ZM23.8 0.300012V0.200012H23.7C23.6 0.200012 14.5 1.40001 9.3 11.9C5.5 19.5 5.7 21.8 6 21.8C6.3 21.9 9.4 15.3 12.7 12.6C17.9 11.5 19.3 9.00001 19.3 9.00001C19.3 9.00001 17.8 9.20001 17.2 9.20001C16.4 9.20001 15.8 9.00001 15.5 8.90001C16.8 7.70001 17.9 7.40001 19 7.20001C19.9 7.00001 20.8 6.80001 22 6.00001C24.2 4.40001 23.9 0.500012 23.8 0.300012Z"
          fill="black"
        />
      </svg>
    </div>
    <router-link :to="{ name: 'admin-users' }" v-show="!isUserPage">
      <svg
        width="18"
        height="21"
        viewBox="0 0 18 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.00003 10.8158C10.355 10.8158 11.872 10.6658 12.84 9.55976C13.654 8.62976 13.918 7.19176 13.646 5.16776C13.266 2.34276 11.529 0.655762 9.00003 0.655762C6.47103 0.655762 4.73403 2.34276 4.35403 5.16976C4.08203 7.19176 4.34603 8.62976 5.16003 9.55976C6.12803 10.6668 7.64503 10.8158 9.00003 10.8158ZM5.84003 5.36776C6.00203 4.16776 6.62703 2.15576 9.00003 2.15576C11.373 2.15576 11.998 4.16876 12.16 5.36776C12.367 6.91776 12.217 7.99476 11.71 8.57276C11.255 9.09276 10.444 9.31576 9.00003 9.31576C7.55603 9.31576 6.74503 9.09276 6.29003 8.57276C5.78303 7.99476 5.63303 6.91676 5.84003 5.36776ZM17.28 18.2358C16.403 14.7098 12.998 12.2458 9.00003 12.2458C5.00203 12.2458 1.59703 14.7098 0.720027 18.2358C0.548027 18.9278 0.692027 19.6358 1.11503 20.1758C1.52303 20.6958 2.15503 20.9958 2.84803 20.9958H15.152C15.845 20.9958 16.477 20.6958 16.885 20.1758C17.309 19.6358 17.452 18.9288 17.279 18.2358H17.28ZM15.704 19.2518C15.578 19.4118 15.388 19.4978 15.152 19.4978H2.84803C2.61303 19.4978 2.42203 19.4128 2.29603 19.2518C2.15903 19.0778 2.11603 18.8398 2.17603 18.5978C2.88603 15.7428 5.69303 13.7478 9.00003 13.7478C12.307 13.7478 15.114 15.7418 15.824 18.5978C15.884 18.8398 15.841 19.0778 15.704 19.2518Z"
          fill="white"
        />
      </svg>
    </router-link>
    <div @click="logout" to="/signin" v-show="!isUserPage">
      <svg
        class="strokeLine"
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 13L5 9M5 9L9 5M5 9H19M14 13V14C14 14.7956 13.6839 15.5587 13.1213 16.1213C12.5587 16.6839 11.7956 17 11 17H4C3.20435 17 2.44129 16.6839 1.87868 16.1213C1.31607 15.5587 1 14.7956 1 14V4C1 3.20435 1.31607 2.44129 1.87868 1.87868C2.44129 1.31607 3.20435 1 4 1H11C11.7956 1 12.5587 1.31607 13.1213 1.87868C13.6839 2.44129 14 3.20435 14 4V5"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <router-link v-show="isUserPage" to="/signup">
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.697 15.468C19.677 15.452 17.557 13.828 17.594 9.43799C17.614 6.90599 16.782 4.65599 15.247 3.10299C13.872 1.70999 12.01 0.939993 10.005 0.929993H9.992C7.988 0.939993 6.126 1.70999 4.75 3.10399C3.216 4.65699 2.382 6.90599 2.404 9.43799C2.441 13.768 0.384001 15.405 0.302002 15.468C0.0420015 15.661 -0.0639986 15.998 0.0370014 16.306C0.139001 16.614 0.427002 16.821 0.749002 16.821H5.669C5.771 19.131 7.666 20.981 9.999 20.981C12.332 20.981 14.225 19.131 14.326 16.821H19.248C19.57 16.821 19.858 16.615 19.958 16.307C20.061 16 19.955 15.662 19.695 15.469L19.697 15.468ZM10 19.478C8.495 19.478 7.27 18.301 7.172 16.82H12.828C12.728 18.3 11.505 19.48 10 19.48V19.478ZM2.38 15.32C3.12 14.188 3.928 12.292 3.904 9.42399C3.886 7.26399 4.548 5.44199 5.817 4.15699C6.91 3.04999 8.397 2.43699 10 2.42999C11.603 2.43799 13.087 3.04999 14.18 4.15799C15.45 5.44299 16.113 7.26399 16.095 9.42499C16.071 12.293 16.88 14.19 17.62 15.321H2.38V15.32Z"
          fill="black"
        />
      </svg>
    </router-link>
    <router-link v-show="isUserPage" to="/signin">
      <svg
        width="20"
        height="19"
        viewBox="0 0 20 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.25 0.0180054H2.75C1.233 0.0180054 0 1.25201 0 2.77001V15.265C0 16.783 1.233 18.018 2.75 18.018H17.25C18.767 18.018 20 16.783 20 15.265V2.77001C20 1.25201 18.767 0.0180054 17.25 0.0180054ZM2.75 1.51801H17.25C17.94 1.51801 18.5 2.07801 18.5 2.76801V3.48201L10.45 8.84901C10.177 9.02901 9.824 9.03101 9.55 8.84701L1.5 3.48201V2.76801C1.5 2.07801 2.06 1.51801 2.75 1.51801ZM17.25 16.516H2.75C2.06 16.516 1.5 15.956 1.5 15.266V5.24001L8.74 10.07C9.123 10.326 9.562 10.454 10 10.454C10.44 10.454 10.877 10.326 11.26 10.071L18.5 5.24101V15.263C18.5 15.953 17.94 16.513 17.25 16.513V16.516Z"
          fill="black"
        />
      </svg>
    </router-link>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isUserPage: false,
    };
  },
  created() {
    const routeName = this.$route.name;
    const adminRoute = ["admin-tweets", "admin-users"];
    if (!adminRoute.includes(routeName)) {
      this.isUserPage = true;
    }
  },
  methods: {
    logout() {
      this.$store.commit("revokeAuthentication");
      this.$router.push("/signin");
    },
  },
};
</script>

<style lang="scss" scoped>
path[fill] {
  fill: var(--primary-text-color);
}
path[storke] {
  stroke: var(--primary-text-color);
}
.router-link-active {
  path[fill] {
    fill: var(--primary-color);
  }
  path[stoke] {
    stroke: var(--primary-color);
  }
}
.container {
  background-color: var(--white-text-color);
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 50px;
  display: flex;
  box-shadow: 7px 0 3px 2px rgba(0, 0, 0, 0.2);
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  z-index: 9999;
}
.post-item {
  cursor: pointer;
}
// 計算出來手機版navbar要消失在865px=235+30+600
@media screen and (min-width: 865px) {
  .container {
    display: none;
  }
}
</style>
